<!--
  @description 菜单管理
  @author xiehan
  @date 2018/12/12
-->
<template>
  <div class="menuManage-wrap menuManage__content">
    <div class="tree-wrap">
      <div class="tree-wrap__btn">
        <div v-text="$t('menuManage.menu')" class="detail-title mb-base ilb"></div>
        <el-button type="primary"
          @click="handleMenu(false)"
          style="float: right;"
          v-g-rac="gRac('menuManage_add')"
          v-text="$t('common.add')"></el-button>
      </div>
      <el-tree
        :data="menuList"
        :props="defaultProps"
        :highlight-current="true"
        accordion
        :expand-on-click-node="false"
        @node-click="handleNodeClick">
        <span class="custom-tree-node" slot-scope="{ node, data }">
          <span>{{ node.label }}</span>
          <span>
            <el-button
              v-g-rac="gRac('menuManage_amend')"
              type="text"
              size="mini"
              @click="() => handleMenu(true, data)">
              {{ $t('common.edit') }}
            </el-button>
            <el-button
              v-g-rac="gRac('menuManage_delete')"
              type="text"
              size="mini"
              @click="() => removeMenu(data)">
              {{ $t('common.delete') }}
            </el-button>
          </span>
        </span>
      </el-tree>
    </div>
    <div class="detail-wrap ml-base" v-show="Object.keys(menuInfo).length > 0">
      <div v-text="$t('menuManage.detail') + '：'" class="detail-title mb-base"></div>
      <el-row :gutter="20" class="mb-base">
        <el-col :span="11" class="text-ellipsis">
          <div v-text="$t('menuManage.menuName') + '：'" class="detail-name"></div>
          <span v-text="menuInfo.name" :title="menuInfo.name"></span>
        </el-col>
        <el-col :span="13" class="text-ellipsis">
          <div v-text="'url:'" class="detail-name"></div>
          <span v-text="menuInfo.url" :title="menuInfo.url"></span>
        </el-col>
      </el-row>
      <el-row :gutter="20" class="mb-base">
        <el-col :span="11">
          <div v-text="$t('menuManage.desc') + '：'" class="detail-name"></div>
          <span v-text="menuInfo.description"></span>
        </el-col>
        <el-col :span="13">
          <div v-text="'id:'" class="detail-name"></div>
          <span v-text="menuInfo.id"></span>
        </el-col>
      </el-row>
      <el-row :gutter="20" class="mb-base">
        <el-col :span="11" class="text-ellipsis">
          <div v-text="$t('menuManage.code') + '：'" class="detail-name"></div>
          <span v-text="menuInfo.code" :title="menuInfo.code"></span>
        </el-col>
        <el-col :span="13">
          <div v-text="$t('menuManage.parentMenu') + '：'" class="detail-name"></div>
          <span v-text="menuInfo.parentMenu"></span>
        </el-col>
      </el-row>
      <el-row :gutter="20" class="mb-base">
        <el-col :span="11">
          <div v-text="$t('menuManage.sort') + '：'" class="detail-name"></div>
          <span v-text="menuInfo.sortIndex"></span>
        </el-col>
        <el-col :span="13">
          <div v-text="$t('menuManage.inPage') + '：'" class="detail-name"></div>
          <span>{{ menuInfo.inPage | inPage }}</span>
        </el-col>
      </el-row>
      <div class="mb-base detail-interface__wrap">
        <div v-text="$t('menuManage.interface') + '：'" class="detail-name ilb"></div>
        <table class="ilb" v-if="menuInfo.authList && menuInfo.authList.length > 0">
          <thead>
            <tr>
              <th class="t-border" v-text="$t('menuManage.interfaceName')"></th>
              <th class="t-border t-border__max" v-text="'URL'"></th>
            </tr>
          </thead>
          <tbody>
            <tr v-for="(item, index) in menuInfo.authList" :key="item.url + index">
              <td class="t-border" v-text="item.interfaceName"></td>
              <td class="t-border t-border__max" v-text="item.url"></td>
            </tr>
          </tbody>
        </table>
        <span v-else v-text="$t('common.none')"></span>
      </div>
      <div v-text="$t('menuManage.menuButton') + '：'" class="detail-name ilb"></div>
      <el-button type="primary"
        class="mb-base"
        @click="handleButton(true, item)"
        v-for="item in buttonList"
        :key="item.code"
        v-text="item.name"></el-button>
      <el-button type="primary"
        @click="handleButton(false)"
        v-text="'+'"></el-button>
    </div>
    <el-dialog :closeOnClickModal="false"
      :title="menuDiaTitle"
      :visible.sync="menuDiaVis"
      width="700px">
      <el-form ref="handleMenuForm" 
        :inline="true"
        :model="handleMenuForm" 
        input-width="220px" 
        label-width="88px" 
        :rules="menuFormRules">
        <el-form-item :label="isMenu ? $t('menuManage.menuName') + '：' : $t('menuManage.buttonName') + '：'" prop="name">
          <el-input v-model="handleMenuForm.name"></el-input>
        </el-form-item>
        <el-form-item label="url：" prop="url" v-show="isMenu">
          <el-input v-model="handleMenuForm.url"></el-input>
        </el-form-item>
        <el-form-item :label="$t('menuManage.desc') + '：'" prop="description">
          <el-input v-model="handleMenuForm.description"></el-input>
        </el-form-item>
        <el-form-item label="id：" prop="id" v-show="isMenu">
          <el-input v-model="handleMenuForm.id" :disabled="true"></el-input>
        </el-form-item>
        <el-form-item :label="$t('menuManage.code') + '：'" prop="code">
          <el-input v-model="handleMenuForm.code"></el-input>
        </el-form-item>
        <el-form-item :label="isMenu ? $t('menuManage.parentMenu') + '：' : $t('menuManage.belongMenu') + '：'" prop="parentID">
          <el-cascader
            v-if="isMenu"
            change-on-select
            :options="selectMenuList"
            v-model="handleMenuForm.parentID"
          ></el-cascader>
          <el-input
            v-else
            :disabled="true"
            v-model="handleMenuForm.parentID"
          ></el-input>
        </el-form-item>
        <el-form-item :label="$t('menuManage.sort') + '：'" prop="sortIndex" v-show="isMenu">
          <el-input-number :min="1" v-model.number="handleMenuForm.sortIndex"></el-input-number>
        </el-form-item>
        <el-form-item :label="$t('menuManage.inPage') + '：'" prop="inPage" label-width="120px" input-width="100px" v-show="isMenu">
          <el-checkbox v-model="handleMenuForm.inPage">{{ $t('menuManage.yes') }}</el-checkbox>
        </el-form-item>
        <el-form-item :label="$t('menuManage.interface') + '：'" input-width="auto">
          <table>
            <thead>
              <tr>
                <th class="t-border" v-text="$t('menuManage.interfaceName')"></th>
                <th class="t-border t-border__max" v-text="'URL'"></th>
                <th class="t-border t-border__none">
                  <el-button type="primary" @click="addAuthList" v-text="$t('common.add')"></el-button>
                </th>
              </tr>
            </thead>
            <tbody>
              <tr v-for="(item, index) in authList" :key="'key' + index">
                <td class="t-border">
                  <el-input v-model="item.interfaceName"></el-input>
                </td>
                <td class="t-border t-border__max">
                  <el-input v-model="item.url"></el-input>
                </td>
                <td class="t-border t-border__none">
                  <el-button type="primary" @click="deleteAuthList(index)" v-text="'--'" style="width: 62px;"></el-button>
                </td>
              </tr>
            </tbody>
          </table>
        </el-form-item>
      </el-form>
      <span slot="footer" class="dialog-footer">
        <el-button @click="menuDiaVis = false" v-text="$t('common.cancel')"></el-button>
        <el-button type="danger" @click="removeButton" v-text="$t('common.delete')" v-show="!isMenu && isEdit"></el-button>
        <el-button type="primary" @click="confirmMenu" v-text="$t('common.confirm')"></el-button>
      </span>
    </el-dialog>
  </div>
</template>

<script>
  import rac from '@/plugins/rac-mixin'
  import menuManageBiz from '@/logic/systemSetting/menuManageBiz'
  let vm = null
  export default {
    mixins: [rac],
    data () {
      vm = this
      return {
        menuList: [],
        defaultProps: {
          children: 'children',
          label: 'label'
        },
        primaryList: [],
        buttonList: [],
        menuInfo: {},
        menuDiaTitle: '',
        menuDiaVis: false,
        selectMenuList: [],
        handleMenuForm: {
          name: '',
          url: '',
          description: '',
          id: '',
          code: '',
          parentID: ['0'],
          sortIndex: 1,
          inPage: false,
          authList: []
        },
        authList: [],
        menuFormRules: {},
        isEdit: false,
        isMenu: false
      }
    },
    methods: {
      removeMenu (data) {
        this.$confirm(this.$t('common.deleteTips'), this.$t('common.delete'), {
          confirmButtonText: this.$t('common.confirm'),
          cancelButtonText: this.$t('common.cancel'),
          type: 'warning'
        }).then(() => {
          menuManageBiz.deleteMenu({ id: data.id }).then(() => {
            this.successMessage()
            this.getAllList()
            this.menuInfo = {}
          })
        }).catch(() => {})
      },
      removeButton () {
        this.removeMenu(this.handleMenuForm)
      },
      getAllList () {
        menuManageBiz.getAll().then(data => {
          this.primaryList = data
          this.setSelectMenuList(data)
          let firstList = data.filter(item => item.type === 'MENU' && item.level === '1')
          let secondList = data.filter(item => item.type === 'MENU' && item.level === '2')
          let thirdList = data.filter(item => item.type === 'MENU' && item.level === '3')
          this.setChildrenList(secondList, thirdList)
          this.setChildrenList(firstList, secondList)
          this.setMenuList(firstList)
          this.menuDiaVis = false
        })
      },
      setMenuList (list, isSelect = false) {
        let arr = isSelect ? 'selectMenuList' : 'menuList'
        this[arr] = []
        if (isSelect) {
          this[arr].push({
            label: this.$t('menuManage.topMenu'),
            value: '0'
          })
        }
        this.sortList(list).map(item => {
          this[arr].push({
            label: item.name,
            value: item.id,
            children: item.children,
            parentMenu: this.$t('menuManage.topMenu'),
            ...item
          })
        })
      },
      setSelectMenuList (data) {
        let arr = []
        data.map(item => arr.push(item))
        let firstList = arr.filter(item => item.type === 'MENU' && item.level === '1')
        let secondList = arr.filter(item => item.type === 'MENU' && item.level === '2')
        this.setChildrenList(firstList, secondList, true)
        this.setMenuList(firstList, true)
      },
      setChildrenList (parents, children, isSelect = false) {
        parents.map(pItem => {
          pItem.children = []
          children.map(cItem => {
            if (pItem.id === cItem.parentID) {
              let obj = {
                label: cItem.name,
                parentMenu: pItem.name,
                value: cItem.id,
                ...cItem
              }
              if (!isSelect) obj.children = cItem.children
              pItem.children.push(obj)
            }
          })
          this.sortList(pItem.children)
        })
      },
      sortList (arr) {
        return arr.sort((a, b) => {
          return Number(a.sortIndex) - Number(b.sortIndex)
        })
      },
      handleNodeClick (data) {
        this.menuInfo = data
        this.findButtonList(data.id)
      },
      findButtonList (id) {
        this.buttonList = this.primaryList.filter(item => item.type === 'BUTTON' && item.parentID === id)
      },
      handleButton (isEdit = false, data) {
        this.isMenu = false
        this.isEdit = isEdit
        this.menuDiaVis = true
        this.menuDiaTitle = isEdit ? this.$t('menuManage.editButton') : this.$t('menuManage.addButton')
        this.setMenuRules(true)
        if (isEdit) {
          for (let i in this.handleMenuForm) {
            this.handleMenuForm[i] = data[i]
          }
          this.handleMenuForm['parentID'] = this.menuInfo.name
          this.authList = [ ...data['authList'] ]
        } else {
          for (let i in this.handleMenuForm) {
            this.handleMenuForm[i] = ''
          }
          this.handleMenuForm.authList = []
          this.authList = []
          this.handleMenuForm['parentID'] = this.menuInfo.name
          this.$nextTick(() => {
            this.$refs['handleMenuForm'].clearValidate()
          })
        }
      },
      handleMenu (isEdit = false, data) {
        this.isMenu = true
        this.isEdit = isEdit
        this.menuDiaVis = true
        this.menuDiaTitle = isEdit ? this.$t('menuManage.editMenu') : this.$t('menuManage.addMenu')
        this.setMenuRules()
        if (isEdit) {
          for (let i in this.handleMenuForm) {
            this.handleMenuForm[i] = data[i]
            if (i === 'parentID' && data.level === '3') {
              let parentParentId = this.primaryList.filter(item => item.id === data.parentID)[0].parentID
              this.handleMenuForm[i] = [parentParentId, data.parentID]
            } else if (i === 'parentID' && (data.level === '1' || data.level === '2')) {
              this.handleMenuForm[i] = [data[i]]
            }
          }
          this.authList = [ ...this.handleMenuForm.authList ]
        } else {
          for (let i in this.handleMenuForm) {
            this.handleMenuForm[i] = ''
          }
          this.handleMenuForm.id = this.findMaxId()
          this.handleMenuForm.parentID = ['0']
          this.handleMenuForm.sortIndex = 1
          this.handleMenuForm.inPage = false
          this.handleMenuForm.authList = []
          this.authList = []
          this.$nextTick(() => {
            this.$refs['handleMenuForm'].clearValidate()
          })
        }
      },
      setMenuRules (isButton = false) {
        this.menuFormRules = {
          name: [
            { required: true, message: `${this.$t('common.entryTips')}${this.$t('menuManage.menuName')}` }
          ],
          url: [
            { required: true, message: `${this.$t('common.entryTips')}url` }
          ],
          description: [
            { required: true, message: `${this.$t('common.entryTips')}${this.$t('menuManage.desc')}` }
          ],
          code: [
            { required: true, message: `${this.$t('common.entryTips')}${this.$t('menuManage.code')}` }
          ]
        }
        if (isButton) delete this.menuFormRules.url
      },
      addAuthList () {
        this.authList.push({
          interfaceName: '',
          url: ''
        })
      },
      deleteAuthList (i) {
        this.authList.splice(i, 1)
      },
      confirmMenu () {
        this.$refs['handleMenuForm'].validate((valid) => {
          if (valid) {
            let saveObj = { ...this.handleMenuForm }
            saveObj.authList = this.authList
            saveObj.parentID = this.isMenu ? saveObj.parentID[saveObj.parentID.length - 1] : this.menuInfo.id
            saveObj.type = this.isMenu ? 'MENU' : 'BUTTON'
            if (this.isMenu) {
              if (saveObj.parentID === '0') {
                saveObj.level = '1'
              } else {
                saveObj.level = String(Number(this.primaryList
                  .filter(item => item.id === saveObj.parentID)[0].level) + 1)
              }
            } else {
              if (!this.isEdit) {
                delete saveObj.id
              }
            }
            let eventName = this.isEdit ? 'updateMenu' : 'addMenu'
            menuManageBiz[eventName](saveObj).then(data => {
              this.successMessage()
              this.getAllList()
              this.menuInfo = {}
            })
          } else {
            return false
          }
        })
      },
      findMaxId () {
        let max = 0
        this.primaryList.map(item => {
          if (item.type === 'MENU' && Number(item.id) > max) {
            max = Number(item.id)
          }
        })
        return max + 1
      },
      successMessage () {
        this.$message({
          message: this.$t('common.success'),
          type: 'success'
        })
      }
    },
    mounted () {
      this.getAllList()
    },
    filters: {
      inPage (val) {
        return val ? vm.$t('menuManage.yes') : vm.$t('menuManage.no')
      }
    }
  }
</script>

<style>
  .menuManage-wrap {
    height: 100%;
    display: flex
  }
  .menuManage-wrap .custom-tree-node {
    flex: 1;
    display: flex;
    align-items: center;
    justify-content: space-between;
    font-size: 14px;
    padding-right: 8px;
  }
  .menuManage-wrap .tree-wrap {
    height: 100%;
    min-width: 310px;
    width: 310px;
    overflow-y: scroll;
    display: inline-block;
  }
  .menuManage-wrap .tree-wrap__btn {
    overflow: hidden;
  }
  .menuManage-wrap .detail-wrap {
    width: 100%;
    display: inline-block;
  }
  .menuManage-wrap .detail-title {
    font-weight: bolder;
  }
  .menuManage-wrap .detail-name {
    width: 110px;
    text-align: right;
    display: inline-block;
  }
  .menuManage-wrap .detail-interface__wrap {
    display: flex;
    align-items: center;
  }
  .menuManage-wrap .t-border {
    height: 28px;
    width: 160px;
    padding: 0 4px;
    border: 1px solid #ddd;
    text-align: center;
    font-weight: normal;
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;
  }
  .menuManage-wrap .t-border input {
    border: none;
  }
  .menuManage-wrap .t-border__max {
    width: 300px;
  }
  .menuManage-wrap .t-border__none {
    border: none;
    width: auto;
    padding: 0;
  }
  .menuManage-wrap table {
    border-collapse: collapse;
    border-spacing: 0;
  }
  .menuManage-wrap .text-ellipsis {
    overflow:hidden;
    text-overflow:ellipsis;
    white-space:nowrap
  }
</style>